<template>
    <Modal :isOpen="isOpen" @close="$emit('close')">
        <template #title>
            <div class="flex items-center gap-3">
                <div
                    class="w-12 h-12 p-3.5 bg-red-50 rounded-full flex items-center justify-center"
                >
                    <Icon
                        icon="trash"
                        class="w-6 h-6 text-red-500"
                        pathClass=""
                    />
                </div>
                <h2 class="text-xl font-medium text-slate-800">
                    Delete connection
                </h2>
            </div>
        </template>

        <template #content>
            <div class="space-y-6">
                <p class="text-sm text-slate-800">
                    You are about to delete the connection to
                    {{ connection.name }}. Removing this connection will also
                    delete all associated data from your My10x account. This
                    action cannot be undone.
                </p>

                <div class="space-y-2">
                    <label
                        for="confirm-text"
                        class="block text-sm font-medium text-slate-600"
                    >
                        Please enter "Delete connection" to confirm you would
                        like to remove
                        <span>
                            {{ nickname ? nickname : 'this connection' }}.
                        </span>
                    </label>
                    <input
                        id="confirm-text"
                        type="text"
                        placeholder="Enter confirm text"
                        class="block w-full bg-white rounded border border-slate-200 py-1.5 text-gray-900 placeholder:text-slate-500 placeholder:text-sm transition-colors focus:ring-0 focus:border-slate-800 hover:border-slate-800 disabled:opacity-50 disabled:cursor-not-allowed"
                        v-model="confirmText"
                    />
                </div>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-end gap-2">
                <button
                    class="px-4 py-2.5 bg-white rounded shadow text-sm font-medium border border-slate-200 text-slate-800 hover:bg-slate-50 transition-colors active:bg-slate-200 focus:outline-slate-200 focus:border-slate-200 hover:border-slate-300 active:border-slate-300"
                    @click="$emit('close')"
                >
                    Cancel
                </button>
                <button
                    class="px-4 py-2.5 bg-red-600 rounded shadow text-sm font-medium text-white hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed active:bg-slate-200 focus:outline-slate-200 focus:border-slate-200 hover:border-slate-300 active:border-slate-300"
                    :disabled="!isConfirmTextValid"
                    @click="handleDelete"
                >
                    Delete
                </button>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { ref, computed } from 'vue';
import Modal from '@/components/ui/modal/ui-modal.vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
    connection: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['close', 'delete']);
const confirmText = ref('');

const isConfirmTextValid = computed(() => {
    return confirmText.value.toLowerCase() === 'delete connection';
});

const nickname = computed(() => {
    return props.connection.connect_attempt?.connection_nickname;
});

function handleDelete() {
    if (isConfirmTextValid.value) {
        emit('delete');
        confirmText.value = '';
    }
}
</script>
